import React, { useCallback, useEffect, useRef, useState } from "react";

import { Box } from "@mui/system";

import ScrollProgress from "../common/scroll-progess/ScrollProgress";
import Intro from "./intro/Intro";
import Skills from "./skills/Skills";
import WorkExperience from "./work-experience/WorkExperience";

import "./aboutMe.scss";

const AboutMe = () => {
    const scrollRef = useRef();

    const [progress, setProgress] = useState(0);

    const handleScroll = useCallback(() => {
        const progess = parseInt(
            Math.ceil(
                (scrollRef.current.scrollTop /
                    (scrollRef.current.scrollHeight -
                        scrollRef.current.clientHeight)) *
                    100
            )
        );
        setProgress(progess <= 100 ? progess : 100);
    }, []);

    useEffect(() => {
        if (scrollRef.current && !scrollRef.current.onscroll) {
            scrollRef.current.addEventListener("scroll", handleScroll, false);
        }
        return () =>
            scrollRef.current &&
            scrollRef.current.removeEventListener(
                "scroll",
                handleScroll,
                false
            );
    }, [scrollRef, handleScroll]);

    return (
        <>
            <ScrollProgress progress={progress} />
            <Box
                ref={scrollRef}
                className="aboutMeContainer flexGrow of-auto p-2"
            >
                <Box className="aboutMe">
                    <Intro />
                    <Skills />
                    <WorkExperience />
                </Box>
            </Box>
        </>
    );
};

export default AboutMe;
